import * as types from "./mutation-types";

export default {
  setEventAssignmentActive(state, payload){
    state.event_assignment_active = payload
  }
};
